/* DSL Real-time stock — refresh every 30s, broadcast events */
(function(){
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var lastStock = {};
  function poll(){
    fetch("/products/" + handle + ".js").then(function(r){return r.json();}).then(function(p){
      p.variants.forEach(function(v){
        var prev = lastStock[v.id];
        if (prev !== undefined && prev !== v.available) {
          document.dispatchEvent(new CustomEvent("dsl:stock:change", {detail: {variant_id: v.id, available: v.available, qty: v.inventory_quantity}}));
          if (window.DSL_BANNER && !v.available && prev) window.DSL_BANNER.show({text: "⚠️ Variant '" + v.title + "' is zojuist uitverkocht.", variant: "error"});
        }
        lastStock[v.id] = v.available;
      });
    }).catch(function(){});
  }
  poll();
  setInterval(function(){ if (document.visibilityState === "visible") poll(); }, 30000);
})();